'use client';

import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    sid: string;
    ballotPreviewRedirectUrl: string;
};

const Client = (props: Readonly<Props>) => {
    const { sid, ballotPreviewRedirectUrl } = props;

    useEffect(() => {
        const { regionPreviewStore } = getStore();
        regionPreviewStore.setSid(sid);
        regionPreviewStore.setBallotPreviewRedirectUrl(ballotPreviewRedirectUrl);
    }, [sid, ballotPreviewRedirectUrl]);

    return null;
};

export default Client;
